<script lang="ts">
	import Welcome from "./pages/Welcome.svelte";
	import IMEI from "./pages/IMEI.svelte";
	import Mounting from "./pages/Mounting.svelte";
	import Asset from "./pages/Asset.svelte";
	import Test from "./pages/Test.svelte";
	import End from "./pages/End.svelte";
	import Icon from "./components/Icon.svelte";
	import Manuals from "./pages/Manuals.svelte";
	import Continue from "./pages/Continue.svelte";
	import type { ComponentType } from "svelte";
	import { messageInfo } from "./store";
	import { fly } from "svelte/transition";

	//Main pages to show on navigation, some optional if handler (third position) return false
	const PAGES: [string, ComponentType, () => boolean][] = [
		["Bienvenue", Welcome, () => true],
		["Reprise", Continue, () => $messageInfo.imei != ""],
		["Numéro", IMEI, () => $messageInfo.imei == ""],
		["Montage", Mounting, () => true],
		["Véhicule", Asset, () => true],
		["Tests", Test, () => true],
		["Fin", End, () => true],
	];

	//Extra pages definition, not shown on navigation
	const EXTRA_PAGES: [string, ComponentType, () => boolean][] = [
		...PAGES,
		["Notices", Manuals, () => true],
	];

	let pageIndex = 0;
	let direction = 1;
	push();

	window.addEventListener("popstate", (ev) => {
		direction = ev.state.page > pageIndex ? 1 : -1;
		pageIndex = ev.state.page;
	});

	function push() {
		history.pushState({ page: pageIndex }, "");
	}

	function next() {
		if (pageIndex + 1 == PAGES.length) {
			window.location.reload();
			return;
		}
		++pageIndex;
		direction = 1;

		while (PAGES[pageIndex][2]() == false) {
			next();
			return;
		}

		push();
	}

	function goManual() {
		if (pageIndex < PAGES.length) {
			pageIndex = EXTRA_PAGES.findIndex((value) => value[1] == Manuals);
			push();
		} else history.back();
	}
</script>

<main>
	<!-- Show logo -->
	<nav class="navbar">
		<div class="container-fluid">
			<a class="navbar-brand" href={window.location.href}>
				<img
					src="logo.png"
					alt="Logo"
					height="24"
					class="d-inline-block align-text-top"
				/>
			</a>
			<button on:click={goManual} class="btn btn-danger">
				Notices&nbsp;
				<Icon icon="box-arrow-up-right" />
			</button>
		</div>
	</nav>

	<!-- Show navigation status -->
	<ul>
		{#each PAGES as page, i}
			{#if page[0]}
				{#if i > 0}
					<Icon icon="chevron-right" />
				{/if}
				<li class={i == pageIndex ? "active" : ""}>{page[0]}</li>
			{/if}
		{/each}
	</ul>

	<!-- Form contains current page -->
	{#key pageIndex}
		<form
			on:submit|preventDefault={next}
			in:fly={{ x: 400 * direction, duration: 250, delay: 150 }}
			out:fly={{ x: -400 * direction, duration: 100 }}
		>
			<svelte:component this={EXTRA_PAGES[pageIndex][1]} />
		</form>
	{/key}
</main>

<style>
	nav {
		background-color: #1b1358;
	}
	ul {
		padding: 0;
		margin: 5px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	li {
		display: inline;
		color: #1b1358;
		padding: 2px;
	}
	li.active {
		background-color: #1b1358;
		color: white;
		border-radius: 5px;
	}
	form {
		max-width: 600px;
		margin: 0 auto;
		padding: 10px;
	}
	main {
		zoom: 90%;
	}
</style>
